module.exports = __webpack_public_path__ + "img/XDN.a6bc640d.svg";